
import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';

export default function HomePage() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    // Schema.org JSON-LD for LocalBusiness
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "MedicalBusiness",
      "name": "南森町鍼灸院",
      "description": "女性・小児専門（乳幼児〜中学生）の鍼灸治療院。経絡治療、美容鍼、小児鍼を提供。",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/`,
      "telephone": "06-6949-8663",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "東天満2丁目2-3 ダイアパレス南森町704",
        "addressLocality": "大阪市北区",
        "postalCode": "530-0044",
        "addressCountry": "JP"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": "34.6937",
        "longitude": "135.5123"
      },
      "openingHours": [
        "Mo-Sa 10:00-13:00",
        "Mo-Fr 14:30-20:00",
        "Sa 14:00-18:00"
      ],
      "priceRange": "¥¥",
      "medicalSpecialty": ["鍼灸治療", "経絡治療", "美容鍼", "小児鍼"],
      "areaServed": "大阪市北区",
      "founder": {
        "@type": "Person",
        "name": "田村 公子"
      }
    });
    document.head.appendChild(script);

    // Set page title and meta description
    document.title = "南森町鍼灸院 - 女性・小児専門の鍼灸治療院・美容鍼";
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', '南森町駅徒歩5分。大阪天満宮駅徒歩2分。女性・小児専門（乳幼児〜中学生）の鍼灸治療院。経験豊富な女性鍼灸師が、美容鍼、小児はり（夜泣き・疳の虫）などのお悩みに丁寧に対応します。');
    }

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* ヘッダー */}
      <header className="shadow-sm border-b border-gray-100" style={{ backgroundColor: '#D8F25E' }}>
        <div className="max-w-6xl mx-auto px-4 py-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <div className="text-center">
                <h1 className="text-2xl md:text-4xl font-bold" style={{ fontFamily: '"Hiragino Sans", "Noto Sans JP", sans-serif', color: '#526D1A' }}>
                  南森町鍼灸院
                </h1>
                <p className="mt-1 md:mt-2 text-sm md:text-lg opacity-90" style={{ color: '#526D1A' }}>
                  女性・小児専門（乳幼児〜小・中学生）
                </p>
              </div>
              <div className="ml-2 md:ml-0 -mt-2 md:-mt-4">
                <img
                  src="https://static.readdy.ai/image/66b8c69278644cf9dd6637b765df0157/e2fcab9355782d68579ae8474689f655.webp"
                  alt="ハリネズミのマスコット"
                  className="w-16 h-16 md:w-28 md:h-28 object-contain"
                />
              </div>
            </div>

            {/* デスクトップナビゲーション */}
            <nav className="hidden md:flex space-x-6 lg:space-x-8">
              <Link
                to="/"
                className="text-base lg:text-lg font-medium hover:opacity-80 transition-opacity cursor-pointer whitespace-nowrap"
                style={{ color: '#526D1A' }}
              >
                ホーム
              </Link>
              <Link
                to="/about"
                className="text-base lg:text-lg font-medium hover:opacity-80 transition-opacity cursor-pointer whitespace-nowrap"
                style={{ color: '#526D1A' }}
              >
                当院について
              </Link>
              <Link
                to="/menu"
                className="text-base lg:text-lg font-medium hover:opacity-82 transition-opacity cursor-pointer whitespace-nowrap"
                style={{ color: '#526D1A' }}
              >
                治療料金
              </Link>
              <Link
                to="/access"
                className="text-base lg:text-lg font-medium hover:opacity-80 transition-opacity cursor-pointer whitespace-nowrap"
                style={{ color: '#526D1A' }}
              >
                アクセス
              </Link>
              <Link
                to="/contact"
                className="text-base lg:text-lg font-medium hover:opacity-80 transition-opacity cursor-pointer whitespace-nowrap"
                style={{ color: '#526D1A' }}
              >
                ご予約・お問い合わせ
              </Link>
            </nav>

            {/* モバイルメニューボタン */}
            <button
              className="md-hidden p-2 rounded-md cursor-pointer"
              style={{ color: '#526D1A' }}
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
            </button>
          </div>

          {/* モバイルナビゲーション */}
          {isMobileMenuOpen && (
            <nav className="md:hidden mt-4 pb-4 border-t border-gray-200 pt-4">
              <div className="flex flex-col space-y-3">
                <Link
                  to="/"
                  className="text-lg font-medium hover:opacity-80 transition-opacity cursor-pointer py-2"
                  style={{ color: '#526D1A' }}
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  ホーム
                </Link>
                <Link
                  to="/about"
                  className="text-lg font-medium hover:opacity-80 transition-opacity cursor-pointer py-2"
                  style={{ color: '#526D1A' }}
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  当院について
                </Link>
                <Link
                  to="/menu"
                  className="text-lg font-medium hover:opacity-80 transition-opacity cursor-pointer py-2"
                  style={{ color: '#526D1A' }}
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  治療料金
                </Link>
                <Link
                  to="/access"
                  className="text-lg font-medium hover:opacity-80 transition-opacity cursor-pointer py-2"
                  style={{ color: '#526D1A' }}
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  アクセス
                </Link>
                <Link
                  to="/contact"
                  className="text-lg font-medium hover:opacity-80 transition-opacity cursor-pointer py-2"
                  style={{ color: '#526D1A' }}
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  ご予約・お問い合わせ
                </Link>
              </div>
            </nav>
          )}
        </div>
      </header>

      {/* メインビジュアル */}
      <section
        className="relative h-96 bg-cover bg-center"
        style={{
          backgroundImage:
            'url(https://static.readdy.ai/image/66b8c69278644cf9dd6637b765df0157/985607da998fa85ca8ce615efc5d5ddd.webp)',
        }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-30"></div>
        <div className="relative z-10 flex items-center h-full">
          <div className="max-w-6xl mx-auto px-4 w-full">
            <div className="text-left text-white max-w-full lg:max-w-4xl ml-auto lg:ml-32">
              <div className="text-sm md:text-base lg:text-lg leading-relaxed space-y-3 md:space-y-4">
                <p>
                  健康であることが、どんなに素晴らしいことでしょうか。<br />
                  痛みや不調をかかえながらの日々の生活は、身体だけでなく、気持ちまで沈んでしまいます。
                </p>
                <p>
                  よく寝でも、なんだかすっきりしない。<br />
                  病院に行くほどでもないが、なんとなくしんどい。<br />
                  そんな状態が、習慣になっていませんか。
                </p>
                <p>
                  そのような身体の状態に、鍼治療は大きな力を発揮してくれます。<br />
                  あなたの全身を整え、日々を豊かにしてくれる鍼治療を、ぜひお試しください。
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 電話番号セクション */}
      <section className="py-8" style={{ backgroundColor: '#f8f9f0' }}>
        <div className="max-w-6xl mx-auto px-4">
          <div className="text-center">
            <div className="flex justify-center items-center">
              <i className="ri-phone-line text-3xl mr-3" style={{ color: '#526D1A' }}></i>
              <div>
                <p className="text-sm text-gray-600 mb-1">お電話でのご予約・お問い合わせ</p>
                <a 
                  href="tel:06-6949-8663" 
                  className="text-3xl font-bold cursor-pointer hover:opacity-80 transition-opacity"
                  style={{ color: '#526D1A' }}
                >
                  06-6949-8663
                </a>
                <p className="text-sm text-gray-500 mt-1">受付時間：診療時間内</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="max-w-6xl mx-auto px-4 py-12">
        {/* このような症状でお悩みではありませんか？ */}
        <section className="mb-16">
          <h2 className="text-2xl font-bold text-center mb-8" style={{ color: '#526D1A' }}>
            このような症状でお悩みではありませんか？
          </h2>
          <div className="text-center mb-8">
            <p className="text-lg text-gray-700">
              以下のような症状でお困りの方は、ぜひ一度ご相談ください。
            </p>
          </div>
          <div className="grid md:grid-cols-4 gap-4">
            {[
              { icon: 'ri-user-heart-line', title: '肩こり・首の痛み' },
              { icon: 'ri-heart-pulse-line', title: '腰痛・ぎっくり腰' },
              { icon: 'ri-brain-line', title: '頭痛・めまい' },
              { icon: 'ri-flashlight-line', title: '神経痛' },
              { icon: 'ri-heart-line', title: '自律神経失調症' },
              { icon: 'ri-women-line', title: '婦人科系の悩み' },
              { icon: 'ri-star-line', title: '美容鍼' },
              { icon: 'ri-shield-line', title: '免疫力向上' },
            ].map((symptom, index) => (
              <div
                key={index}
                className="bg-white rounded-lg shadow-md p-6 text-center border-t-4"
                style={{ borderTopColor: index % 2 === 0 ? '#526D1A' : '#D8F25E' }}
              >
                <i className={`${symptom.icon} text-3xl mb-3`} style={{ color: '#526D1A' }}></i>
                <h3 className="text-lg font-semibold" style={{ color: '#526D1A' }}>
                  {symptom.title}
                </h3>
              </div>
            ))}
          </div>
        </section>

        {/* 当院の特徴 */}
        <section className="mb-16">
          <h2 className="text-2xl font-bold text-center mb-8" style={{ color: '#526D1A' }}>
            当院の特徴
          </h2>
          <div className="grid md:grid-cols-3 gap-6">
            <div className="bg-white rounded-lg shadow-md p-6 border-t-4" style={{ borderTopColor: '#526D1A' }}>
              <div className="text-center mb-4">
                <i className="ri-women-line text-4xl" style={{ color: '#D8F25E' }}></i>
              </div>
              <h3 className="text-xl font-semibold mb-3 text-center" style={{ color: '#526D1A' }}>
                女性・小児専門
              </h3>
              <p className="text-gray-700 text-center">当院は女性、小児専門の鍼灸院です。</p>
            </div>
            <div className="bg-white rounded-lg shadow-md p-6 border-t-4" style={{ borderTopColor: '#D8F25E' }}>
              <div className="text-center mb-4">
                <i className="ri-calendar-check-line text-4xl" style={{ color: '#526D1A' }}></i>
              </div>
              <h3 className="text-xl font-semibold mb-3 text-center" style={{ color: '#526D1A' }}>
                予約制
              </h3>
              <p className="text-gray-700 text-center">予約制ですので、初めての方も安心してご相談いただけます。</p>
            </div>
            <div className="bg-white rounded-lg shadow-md p-6 border-t-4" style={{ borderTopColor: '#526D1A' }}>
              <div className="text-center mb-4">
                <i className="ri-heart-line text-4xl" style={{ color: '#D8F25E' }}></i>
              </div>
              <h3 className="text-xl font-semibold mb-3 text-center" style={{ color: '#526D1A' }}>
                問診
              </h3>
              <p className="text-gray-700 text-center">
                治療前にお話を伺い、脈や体の反応も含めて、身体の状態や背景を確認します。
              </p>
            </div>
          </div>
        </section>

        {/* 診療時間 */}
        <section className="mb-16">
          <h2 className="text-2xl font-bold text-center mb-8" style={{ color: '#526D1A' }}>
            診療時間
          </h2>
          
          {/* 診療時間表 */}
          <div className="max-w-4xl mx-auto mb-8">
            <div className="bg-white rounded-lg shadow-md overflow-hidden">
              <table className="w-full">
                <thead>
                  <tr style={{ backgroundColor: '#D8F25E' }}>
                    <th className="py-3 px-2 md:py-4 md:px-6 text-left font-semibold text-xs md:text-base" style={{ color: '#526D1A' }}>時間</th>
                    <th className="py-3 px-1 md:py-4 md:px-4 text-center font-semibold text-xs md:text-base" style={{ color: '#526D1A' }}>月</th>
                    <th className="py-3 px-1 md:py-4 md:px-4 text-center font-semibold text-xs md:text-base" style={{ color: '#526D1A' }}>火</th>
                    <th className="py-3 px-1 md:py-4 md:px-4 text-center font-semibold text-xs md:text-base" style={{ color: '#526D1A' }}>水</th>
                    <th className="py-3 px-1 md:py-4 md:px-4 text-center font-semibold text-xs md:text-base" style={{ color: '#526D1A' }}>木</th>
                    <th className="py-3 px-1 md:py-4 md:px-4 text-center font-semibold text-xs md:text-base" style={{ color: '#526D1A' }}>金</th>
                    <th className="py-3 px-1 md:py-4 md:px-4 text-center font-semibold text-xs md:text-base" style={{ color: '#526D1A' }}>土</th>
                    <th className="py-3 px-1 md:py-4 md:px-4 text-center font-semibold text-xs md:text-base" style={{ color: '#526D1A' }}>日</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b border-gray-200">
                    <td className="py-3 px-2 md:py-4 md:px-6 font-medium text-gray-700 text-xs md:text-base">
                      午前<br />
                      <span className="text-xs md:text-sm text-gray-500">10:00〜13:00</span>
                    </td>
                    <td className="py-3 px-1 md:py-4 md:px-4 text-center text-sm md:text-lg font-bold" style={{ color: '#526D1A' }}>◯</td>
                    <td className="py-3 px-1 md:py-4 md:px-4 text-center text-sm md:text-lg font-bold" style={{ color: '#526D1A' }}>◯</td>
                    <td className="py-3 px-1 md:py-4 md:px-4 text-center text-sm md:text-lg font-bold" style={{ color: '#526D1A' }}>◯</td>
                    <td className="py-3 px-1 md:py-4 md:px-4 text-center text-sm md:text-lg font-bold" style={{ color: '#526D1A' }}>◯</td>
                    <td className="py-3 px-1 md:py-4 md:px-4 text-center text-sm md:text-lg font-bold" style={{ color: '#526D1A' }}>◯</td>
                    <td className="py-3 px-1 md:py-4 md:px-4 text-center text-sm md:text-lg font-bold" style={{ color: '#526D1A' }}>◯</td>
                    <td className="py-3 px-1 md:py-4 md:px-4 text-center text-sm md:text-lg font-bold text-red-600">休</td>
                  </tr>
                  <tr>
                    <td className="py-3 px-2 md:py-4 md:px-6 font-medium text-gray-700 text-xs md:text-base">
                      午後<br />
                      <span className="text-xs md:text-sm text-gray-500">平日14:30〜20:00<br />土曜14:00〜18:00</span>
                    </td>
                    <td className="py-3 px-1 md:py-4 md:px-4 text-center text-sm md:text-lg font-bold" style={{ color: '#526D1A' }}>◯</td>
                    <td className="py-3 px-1 md:py-4 md:px-4 text-center text-sm md:text-lg font-bold" style={{ color: '#526D1A' }}>◯</td>
                    <td className="py-3 px-1 md:py-4 md:px-4 text-center text-sm md:text-lg font-bold" style={{ color: '#526D1A' }}>◯</td>
                    <td className="py-3 px-1 md:py-4 md:px-4 text-center text-sm md:text-lg font-bold" style={{ color: '#526D1A' }}>◯</td>
                    <td className="py-3 px-1 md:py-4 md:px-4 text-center text-sm md:text-lg font-bold" style={{ color: '#526D1A' }}>◯</td>
                    <td className="py-3 px-1 md:py-4 md:px-4 text-center text-sm md:lg font-bold" style={{ color: '#526D1A' }}>◯</td>
                    <td className="py-3 px-1 md:py-4 md:px-4 text-center text-sm md:text-lg font-bold text-red-600">休</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div className="text-center">
            <p className="text-gray-600 mb-2"> 日・祝　休鍼</p>
            <p className="text-sm text-gray-500">(研修による臨時休鍼あり)</p>
            <p className="text-sm text-gray-500 mt-2">最終受付：平日18:30 / 土曜16:30</p>
          </div>
        </section>

        {/* CTA セクション */}
        <section className="text-center">
          <div
            className="bg-white rounded-lg shadow-lg p-8 max-w-3xl mx-auto"
            style={{ backgroundColor: '#D8F25E' }}
          >
            <h2 className="text-3xl font-bold mb-6" style={{ color: '#526D1A' }}>
              ご予約・お問い合わせ
            </h2>
            <p className="text-lg text-gray-700 mb-8">
              まずはお気軽にご予約ください。<br />初めての方にも安心して受けていただけるよう、丁寧にお話しを伺います。
            </p>

            <div className="flex flex-col md:flex-row gap-4 justify-center items-center">
              <button
                className="bg-white text-white px-8 py-4 rounded-full text-xl font-bold shadow-xl hover:shadow-2xl transition-all duration-300 cursor-pointer whitespace-nowrap transform hover:scale-105"
                style={{
                  backgroundColor: '#526D1A',
                  border: '3px solid #526D1A',
                }}
                onClick={() => {
                  window.open('https://kenkounihari.seirin.jp/clinic/18451/reserve', '_blank');
                }}
              >
                <i className="ri-calendar-line mr-3"></i>
                今すぐ予約する
              </button>

              <Link
                to="/contact"
                className="bg-white px-8 py-4 rounded-full text-xl font-bold shadow-xl hover:shadow-2xl transition-all duration-300 cursor-pointer whitespace-nowrap transform hover:scale-105 border-3"
                style={{
                  color: '#526D1A',
                  borderColor: '#526D1A',
                }}
              >
                <i className="ri-mail-line mr-3"></i>
                お問い合わせ
              </Link>
            </div>
          </div>
        </section>

      </div>

      {/* フッター */}
      <footer className="mt-16 py-8 text-center text-gray-600" style={{ backgroundColor: '#f8f9f0' }}>
        <div className="max-w-6xl mx-auto px-4">
          <p>&copy; 2025 南森町鍼灸院. All rights reserved.</p>
          <p className="mt-2">
            <a
              href="https://readdy.ai/?origin=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-500 hover:text-gray-700 cursor-pointer"
            >
              Website Builder
            </a>
          </p>
        </div>
      </footer>
    </div>
  );
}
